/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geototallive2Inputs */

const en_geototallive2 = /** @type {(inputs: Geototallive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live now`)
};

const de_geototallive2 = /** @type {(inputs: Geototallive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt live`)
};

/**
* | output |
* | --- |
* | "Live now" |
*
* @param {Geototallive2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geototallive2 = /** @type {((inputs?: Geototallive2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geototallive2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geototallive2(inputs)
	return de_geototallive2(inputs)
});
export { geototallive2 as "geoTotalLive" }